<template>
    <div class="resource-create">
        <div>
            <label><input type="radio" name="resourceType" value="0" v-model="resourceType"/> 写真</label>
            <label><input type="radio" name="resourceType" value="1" v-model="resourceType"/> 動画</label>
        </div>
        <div class="wrapper">
            <div class="resource-area" v-if="resourceType === '0'">
                <input type="file" accept="image/*" @change='inputPicture($event)'>
                <img v-if='pictureObject' :src="picturePath">
                <span>写真</span>
            </div>
            <div class="resource-area" v-if="resourceType === '1'">
                <input type="file" accept="video/*" @change='inputVideo($event)'>
                <video v-if='videoObject' playsinline autoplay muted loop>
                    <source :src="videoPath" type='video/mp4'>
                </video>
                <span>動画</span>
            </div>
        </div>
        <div class="floating-actions">
            <button class="btn" type='button' @click="save">
                保存
            </button>
        </div>
    </div>
</template>
<script>
    import ResizeImage from '@/lib/resizeImage'

    export default {

        name: 'orderQuoteResourceCreate',
        data: function () {
            return {
                resourceType: '0',
                videoObject: null,
                videoPath: null,
                pictureObject: null,
                picturePath: null,
            }
        },
        methods: {
            inputVideo: function (event) {
                this.videoObject = event.target.files[0];
                this.videoPath = URL.createObjectURL(event.target.files[0]);
            },
            inputPicture: function (event) {
                this.selectedFile(event);
            },
            save: function () {
                let type = this.resourceType;
                let image = (type === '0') ? this.pictureObject : this.videoObject;
                this.$api.postOrderQuoteResource(this.$route.params.id, type, image)
                    .then(() => {
                        this.loading = false;
                        this.$$.flash();
                        this.$router.go(-1);
                    })
                    .catch(() => {
                        this.loading = false;
                    })
            },
            async selectedFile(e) {
                this.$$.load();

                const file = e.target.files[0];
                if (!file) {
                    return;
                }

                try {
                    // 圧縮した画像を取得
                    const compFile = await ResizeImage.getCompressImageFileAsync(file);
                    // 画像情報の設定
                    this.pictureObject = compFile;
                    this.picturePath = await ResizeImage.getDataUrlFromFile(compFile);
                } catch (err) {
                    // エラーメッセージ等を表示
                } finally {
                    this.$$.endload();
                }
            }
        },
        mounted: function () {
            this.$$.context({
                title: "資料撮影:" + this.$route.params.id,
                previousRouteName: 'orderQuoteResources',
            });
        }
    }
</script>
<style lang='scss'>
    .resource-create {
        padding: 2em;

        input {
        }

        .wrapper {
            display: flex;
            justify-content: space-between;
        }

        .resource-area {
            display: block;
            position: relative;
            border: 1px dashed #555;
            padding: .5em;
            min-height: 20em;
            margin-bottom: 1em;
            width: 98%;
        }

        img {
            z-index: 2;
            margin: auto;
            display: block;
            max-width: 100%;
            max-height: 100%;
            position: relative;
        }

        video {
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: auto;
            display: block;
            margin: auto;
            position: relative;
            z-index: 2;
        }

        span {
            display: block;
            width: 100%;
            margin-bottom: 1em;
            text-align: center;
            border-radius: 4px;
            position: absolute;
            z-index: 0;
            top: 45%;
            left: 0;
            right: 0;
        }
    }
</style>